import React, { Dispatch, SetStateAction } from 'react';
import Field from '../../../../../interfaces/field';
import indexCss from '../../index.module.css';
import NewMap from './newmap';
import { UseFormSetValue } from 'react-hook-form/dist/types/form';
import { FieldValues } from 'react-hook-form';
import { ActionType } from '../../../../../components/form/elements/map';

interface Props {
  field: Field | Field[];
  setField?: Dispatch<SetStateAction<Field | Field[]>>;
  isEditActive?: boolean;
  isDrawingActive?: boolean;
  height?: number;
  setReload?: Dispatch<SetStateAction<number>>;
  isSplitActive?: boolean;
  isMergeActive?: boolean;
  zoomToMainFeature?: boolean;
  setValue?: UseFormSetValue<FieldValues>;
  isIdentifyActive?: boolean;
  mainFieldId?: string;
  type?: ActionType;
  deleteWaypoint?: string;
  submitted?: string;
  mapLoaded?: boolean;
  hasGeometryChanged?: string;
}

export default function FieldMapWrapper({
  field,
  setField,
  isEditActive,
  isDrawingActive,
  height,
  setReload,
  isSplitActive,
  isMergeActive,
  zoomToMainFeature,
  setValue,
  isIdentifyActive,
  mainFieldId,
  type,
  deleteWaypoint,
  submitted,
  mapLoaded,
  hasGeometryChanged,
}: Props) {
  return (
    <div className={indexCss['map-container']} style={{ height: height }}>
      <NewMap
        key="field-list-map"
        data={Array.isArray(field) ? field : field ? [field] : []}
        isEditActive={isEditActive}
        setField={setField}
        isDrawingActive={isDrawingActive}
        setReload={setReload}
        isSplitActive={isSplitActive}
        isMergeActive={isMergeActive}
        zoomToMainFeature={zoomToMainFeature}
        setValue={setValue}
        isIdentifyActive={isIdentifyActive}
        mainFieldId={mainFieldId}
        type={type}
        deleteWaypoint={deleteWaypoint}
        submitted={submitted}
        mapLoaded={mapLoaded}
        hasGeometryChanged={hasGeometryChanged}
      />
    </div>
  );
}
